import { render, staticRenderFns } from "./QuestionActionButton.vue?vue&type=template&id=2c277d06&"
import script from "./QuestionActionButton.vue?vue&type=script&lang=js&"
export * from "./QuestionActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports